/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-05-26 17:09:45
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-06-08 10:53:15
 * @FilePath: \crm-product\src\views\performanceCalculation\views\result_statement\monthly_terminal_performance_report\table\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import TablePage from '@/found/components/table_page';
import Form from '../form/detail.vue';

export default {
  extends: TablePage,
  components: {
    Form,
  },
  name: 'MonthlyTerminalPerformanceReportTable',
  data() {
    return {

    };
  },
  created() {
    this.getConfigList('main-list');
  },

  methods: {
    afterGetList() {
      this.tableData = this.tableData.map((item) => ({
        ...item,
        monthRate: item.monthRate ? `${item.monthRate}%` : item.monthRate,
      }));
    },
    modalClick({
      val,
      row,
    }) {
      if (val.code === 'detail') {
        this.formConfig = {
          mainId: row.id,
        };
        this.modalConfig.title = '发货明细';
        this.openFull();
      }
    },
  },
};
